import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TablePaginationParams } from 'config/types'
import { paginationParam } from 'config/UIHelpers'

interface ConfiguratorState {
  divisionId: number
  categoryParams: TablePaginationParams
}

const initialState: ConfiguratorState = {
  divisionId: -1,
  categoryParams: {
    ...paginationParam,
    division: -1,
    search: '',
  },
}

const configuratorSlice = createSlice({
  name: 'configurator',
  initialState,
  reducers: {
    setDivisionId(state, action: PayloadAction<number>) {
      state.divisionId = action.payload
      state.categoryParams = {
        ...state.categoryParams,
        division: action.payload,
      }
    },
    setCategoryParams(state, action: PayloadAction<TablePaginationParams>) {
      state.categoryParams = {
        ...state.categoryParams,
        ...action.payload,
        division: state.divisionId,
      }
    },
  },
})

export const { setDivisionId, setCategoryParams } = configuratorSlice.actions
export default configuratorSlice.reducer
